import { Component } from "@eusoft/webapp-core/Component";
import { forModel } from "@eusoft/webapp-jsx/Helpers";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import type { ITemplateContext } from "@eusoft/webapp-core/abstraction/ITemplateContext";
import "./SwipeRefresh.scss";
import { delayAsync } from "@eusoft/webapp-core";

export class SwipeRefresh extends Component {

    protected _isSwiping: boolean = false;  
    protected _touchId: number;
    protected _startY: number;
    protected _lastGoal: number;

    constructor() {
        super();

        this.init(SwipeRefresh, {
            template: forModel<this>(m => <div className={m.className}>
                <span className="icon-container hidden"><MaterialIcon name="refresh" /></span>
                
            </div>)
        });
    }

    override mount(ctx: ITemplateContext) {

        super.mount(ctx);

        const container = ctx.element.querySelector("span");
        const icon = container.querySelector("i");

        document.body.addEventListener("touchstart", ev => {

            if (ev.touches.length > 1)
                return;

            const touch = ev.changedTouches[0];

            if (touch.clientY < this.topMargin) {
                this._touchId = touch.identifier;
                this._startY = touch.clientY;
                this._isSwiping = true;
                this._lastGoal = 0;

            }

        }, { passive: true });

        document.body.addEventListener("touchmove", ev => {

            if (!this._isSwiping)
                return;

            const touch = Array.from(ev.changedTouches).find(a => a.identifier == this._touchId);

            if (!touch)
                return;

            const dy = touch.clientY - this._startY;

            const goal = Math.min(1, Math.max(0, dy / this.refreshDelta));

            if (container.classList.contains("hidden"))
                container.classList.remove("hidden");

            container.style.transform = "rotate(" + Math.round(goal * 360) + "deg)";
            container.style.top = (-40 + goal * this.refreshDelta) + "px";
            
            icon.style.opacity = Math.min(1, Math.max(goal * 2, dy / this.refreshDelta)).toString(); 

            this._lastGoal = goal;

            ev.preventDefault();   

        }, { passive: false });

        document.body.addEventListener("touchend", async ev => {

            if (!this._isSwiping)
                return;

            const touch = Array.from(ev.changedTouches).find(a => a.identifier == this._touchId);

            if (!touch)
                return;

            const isGoal = this._lastGoal > 0.9;

            let hideClass: string;

            if (isGoal)
                hideClass = "hide-goal";
            else
                hideClass = "hide";

            container.classList.add(hideClass);

            await delayAsync(500);

            container.classList.remove(hideClass);
            container.classList.add("hidden");

            this._isSwiping = false;

            if (isGoal) {
                document.location.reload();
            }

        }, { passive: true });
    }


    topMargin: number = 80;

    refreshDelta: number = 150;

}